import { z } from "zod";
import { DataRoutes } from "./types";

const schemaRoutes: DataRoutes = {
  // Get list of schemas filtered by user's team membership
  // Returns schemas for teams user belongs to and RLP schemas (rlp=1)
  'get /api/data/schema': {
    query: `SELECT
      id,
      name,
      teamId,
      entityType,
      rlp,
      [Schema] as [schema]
    FROM DataSchema
    WHERE TeamId IN (
        SELECT TeamId 
        FROM UserTeams 
        WHERE UserId = dbo.fnGetContextUser()
      )
      OR rlp = 1
    ORDER BY TeamId, EntityType, Name
    `
  },

  // Get foreign key relationships for a specific table
  'patch /api/data/schema': {
    schema: z.object({
      name: z.string(),
      schema: z.string()
    }),
    query: `UPDATE DataSchema
    SET [Schema] = @schema,
        updatedBy = dbo.fnGetContextUser(),
        updatedAt = GETDATE()
    WHERE Name = @name
    `
  }
};

export default schemaRoutes;